import { Fragment, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalInfo } from "../../../../Contexts/GlobalContext";
import { Button, Dropdown } from "react-bootstrap";
import AdminListTable from "../AdminListTable";
import RequestorListTable from "./RequestorListTable";
import TokenService from "../../../../Services/Token.service";
import ClearFilterButton from "../../../../Components/ClearFilterButton";
import ExportCSVButton from "../../../../Components/ExportCSVButton";
import { Helmet } from "react-helmet";
import Toaster from "../../../../Components/Toaster";

function RequestorManagement() {
    const navigate = useNavigate();
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0); 
    const [exportCsv, setexportCsv] = useState(false);
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };

    
    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };

    const handleExportCSV = () => {
        setexportCsv(true);
        setTimeout(() => setexportCsv(false), 0);
    }


    const location = useLocation();
    useEffect(() => { 
        if (location.state?.toastMessage) {
                setShowToast(true);
                setToastMessage(location.state.toastMessage);
                setToastVariant(location.state.toastVariant); 


                 // Clear location.state to prevent the toast from triggering on refresh
                 navigate(location.pathname, { replace: true }); 
        }
    },[], [location.state, showToast, navigate]);

    const previousUrl = TokenService.getPrevLink();
    return (
        <>
            <Fragment>
            <Helmet>
                <title>DonorX | Requestor Management</title>
            </Helmet>
                {/* <div className={`el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`}> */}
                {/* <DashboardHeader/> */}
                <div className="el-middle-wrapper">
                    <h2 className="el-title">Requestor Management</h2>
                    <Link className="back-link" to={`/admin/administrative-settings`}><i className='el-icon-back'></i> Administrative Settings</Link>
                    <div className="el-bg-table">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex justify-content-between align-items-center">
                            {/* style={{ width: "45%" }} */}

                                <div style={{marginRight:'15px'}}>
                                    <h3>Requestor List</h3>
                                </div>  
                                <ExportCSVButton handleExportCSV = {handleExportCSV}/>
                                {filterCount > 0 && ( <ClearFilterButton handleClearFilters={handleClearFilters} />)}
                                {filterCount > 0 &&( <span className="m-2">Filters applied: {filterCount}</span> )}
                            </div>
                            <div>
                                <button variant="secondary" onClick={() => {TokenService.updatePrevLink('/admin/requestor-management'); navigate('add-requestor') }} className="el-main-button me-0"> <span><i className="el-icon-add"></i>  Add requestor</span> </button>
                            </div>
                        </div>
                        <>
                            {/* <AdminListTable isClearFilter={isClearFilter} /> */}
                            <RequestorListTable isClearFilter={isClearFilter} onFilterCountChange={handleFilterCountChange} exportCsv={exportCsv} />
                        </>
                    </div>
                </div>
                {/* </div> */}
                <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
            </Fragment>
        </>
    );
}

export default RequestorManagement;